import React from 'react';
import clsx from 'clsx';

import styles from './HighlightCard.module.scss';

interface HighlightCardProps {
  highlight?: boolean;
  className?: string;
  children: React.ReactNode;
}

const HighlightCard: React.FC<HighlightCardProps> = ({ highlight, className, children }) => {
  if (!highlight) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={clsx(styles.highlight, className)}>
      <svg className={styles.snake} aria-hidden="true">
        <rect pathLength="100" />
      </svg>
      <div className={styles.inner}>{children}</div>
      <div className={styles.shimmer} />
    </div>
  );
};

export default HighlightCard;
